import { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { useInstalledAppVersion } from "./index";
import { useDispatch, useSelector } from "react-redux";
import { setInstalledAppVersion } from "../../redux/actions/appStatus";

import * as self from "./appVersionHooks";
import { RootState, store } from "../../redux/store";
import { INSTALLED_VERSION_UNKNOWN } from "../../redux/models/refsixState";

/**
 * Get the current version of the app using the redux state for speed state if set, if not get it from Capacitor plugin
 */
export const getCurrentVersionQuickly = async () => {
    const version = store.getState().appStatus.installedVersion;
    if (!version || version === INSTALLED_VERSION_UNKNOWN) {
        // get version asynchronously
        return await getCurrentInAppVersion();
    } else {
        // get version synchronously
        return version;
    }
};

export const WEB_APP_VERSION = "0.0.0";

export const getCurrentInAppVersion = async (): Promise<string> => {
    try {
        const info = await App.getInfo();
        return info.version;
    } catch (e) {
        // App.getInfo() is native-only, so it throws on web/local
        console.warn("App.getInfo failed", e);
        return WEB_APP_VERSION;
    }
};
export const useCurrentInAppVersion = () => {
    const [currentInAppVersion, setCurrentInAppVersion] = useState<string>("");
    useEffect(() => {
        const run = async () => {
            setCurrentInAppVersion(await getCurrentInAppVersion());
        };
        run();
    }, []);

    return currentInAppVersion;
};

export const useCurrentAppVersion = () => {
    const [currentAppVersion, setCurrentAppVersion] = useState<
        string | undefined
    >();
    useEffect(() => {
        async function getCurrentAppVersion() {
            try {
                // Fails locally
                const info = await App.getInfo();
                setCurrentAppVersion(info.version);
            } catch (e) {}
        }

        getCurrentAppVersion();
    }, []);
    return currentAppVersion;
};
export const useHasNewVersion = (
    excludeVersions: string[] = ["DEV", "UNKNOWN"]
) => {
    const previousAppVersion = useInstalledAppVersion();
    const currentAppVersion = self.useCurrentAppVersion();
    const dispatch = useDispatch();
    const showOnBoardingFlow = useSelector(
        (state: RootState) => state.appStatus.showOnBoardingFlow
    );

    const [hasNewVersion, setHasNewVersion] = useState(false);

    // Save version to the store
    useEffect(() => {
        if (
            currentAppVersion &&
            previousAppVersion &&
            currentAppVersion !== previousAppVersion &&
            !excludeVersions.includes(currentAppVersion) &&
            !showOnBoardingFlow
        ) {
            //console.log("New version", previousAppVersion, currentAppVersion);
            // Dispatch
            dispatch(setInstalledAppVersion(currentAppVersion));
            setHasNewVersion(true);
        }
    }, [excludeVersions, previousAppVersion, currentAppVersion, dispatch]);
    return { hasNewVersion, previousAppVersion, currentAppVersion };
};
